import React from 'react';
import cs from 'classnames';
import { connect } from 'react-redux';
import get from 'lodash/get';

import Spinner from '~/components/common/Spinner';
import * as actionCreators from '~/modules/backhaul/actions';
import mapDispatch from '~/misc/mapDispatch';
import backhaulIdentity from '~/modules/backhaul/backhaulIdentity';
import Point from '~/components/common/DirectionPoint/index.js';
import { formatDate } from '~/misc/dates';
import LoadRow from '~/components/LoadPage/SimilarLoads/Row'
import create from '~/misc/create';
import types from '~/modules/backhaul/types';
import { modalChange } from '~/modules/modal/actions';
import { getLocation, getSearchId } from "~/misc/actionLocation";
import css from './index.css';
import {track} from '~/misc/metrics';

const backToRawData = (data) => {
  return {
    id: data.id,
    load_size: data.load_size,
    equipment: data.equipment,
    broker: {
      company: data.company,
    },
    pickup: {
      date_local: data.from_date_local,
      address: {
        city: data.from_city,
        state: data.from_state,
      }
    },
    drop_off: {
      date_local: data.to_date_local,
      address: {
        city: data.to_city,
        state: data.to_state,
      }
    },
    distance: data.distance,
    length: data.length,
    weight: data.weight,
    load_size: data.load_size,
    price: data.target_price,
  }
}



const LocationName = ({ address }) => {
  if (!address || (!address.city && !address.state)) {
    return (
      <span className={css.locationBlock}>
        <span className={css.special}>Anywhere</span>
      </span>
    );
  }

  if (!address.city) {
    return (
      <span className={css.locationBlock}>
        <span className={css.locationState}>
          {address.state}
        </span>
      </span>
    );
  }

  return (
    <span className={css.locationBlock}>
      <span className={css.locationCity}>
        {address.city.toLowerCase()}{', '}
      </span>
      <span className={css.locationState}>
        {address.state}
      </span>
    </span>
  );
};

const Link = ({ url, isLoggedIn, view, showLogIn, active, children }) => (
  <span className={css.columnLink}>
    {(active)
      && (isLoggedIn
        ? <a href={url} className={css.link} target='_blank' onClick={view}>{children}</a>
        : <span className={css.link} onClick={showLogIn}>{children}</span>)}
  </span>
);

const BackhaulDirection = connect((state, props) => ({
  loadsResource: get(state, ['resources', 'byName', props.loadsIdentity.name, props.loadsIdentity.key]),
  searchId: get(state, "loadsSearch.results.searchId"),
  isLoggedIn: state.user.isLoggedIn,
}), mapDispatch({
  view: ({identity, id}) => {
    track("Load Actions", {
      Action: "View Backhaul Loads",
      loadId: id,
      searchId: getSearchId(),
      Placement: getLocation(),
    })
    return actionCreators.viewBackhaulLane(identity)
  },
  showLogIn: () => modalChange('login', 'anonymous_banner'),
}))(({ query, loadsResource, isLoggedIn, url, view, showLogIn }) => {
  const totalCount = get(loadsResource, 'item.total_shipments');
  const loading = get(loadsResource, 'loading');
  return (
    <div>
      <div className={css.directionWrap}>
        <div className={cs(css.directionTitle, {
          [css.allowBreak]: true,
        })}
        >
          <span className={css.columnDate}>
            {query.dates && query.dates.map((date, num) => <span key={num}>{formatDate(date)}</span>)}
          </span>
          <span className={css.laneLocation}>
            <span className={css.arrow}>→</span>
            <span className={css.columnLocationName}>
              <LocationName address={(query.drop_off && query.drop_off.description)} />
            </span>
          </span>
          <span className={css.columnCount}>{
            loading
              ? <span className={css.spinner}><Spinner scalable={true} /></span>
              : totalCount
          }</span>
          <Link url={url} view={view} active={true} isLoggedIn={isLoggedIn} showLogIn={showLogIn}>View loads</Link>

        </div>
      </div>
    </div>
  );
});

const Backhaul = ({ lists, pickUp, bookingLoad, bookingLoadLoading, active, trackBooknow }) => {
  if (!pickUp) {
    return null;
  }

  return (
    <div
      className={cs('qa-backhaul', css.container)}
    >
      <div className={css.header}>
        <div className={css.title}>
          <span>Backhaul loads</span>{' '}
          <span className={css.locationHeaderDesc}>
            {'from '}
            <Point
              title='Destination'
              text={'B'}
            />
            <LocationName address={pickUp.description} />
            <span title='Deadhead'>{' '} {pickUp.deadhead} {parseInt(pickUp.deadhead) && 'mi'}</span>
          </span>
        </div>
      </div>

      <div className={css.directionsList}>
        {lists && lists.map((list, num) => (<div key={num} className={css.datesSection}>
          {list.map(item => <BackhaulDirection {...item} active={active} key={item.identity.shortkey} />)}
        </div>))}
      </div>

      <div className={css.header}>
        <div className={cs(css.title, !bookingLoad && css.loadingTitle)}>
          Best backhaul load to book
        </div>
        <div className={css.loadWrap}>
          {
            bookingLoad
              ? <LoadRow data={backToRawData(bookingLoad)} compactView={true} />
              : (bookingLoadLoading && <div className={css.spinner}><Spinner scalable={true} /></div> || '-')
          }

        </div>
      </div>

    </div>
  );
};

export default connect(({ backhaul }, { loadIdentity }) => {
  const identity = backhaulIdentity(loadIdentity);
  const { lists, bookingLoad, pick_up: pickUp, bookingLoadLoading } = backhaul.index[identity.key] || {};

  return {
    lists,
    bookingLoad,
    bookingLoadLoading,
    pickUp,
    active: backhaul.active[identity.key],
  };
}, mapDispatch({
  trackBooknow: (props) => create(types.BACKHAUL_BOOKINGLOAD_OPENED, backhaulIdentity(props.loadIdentity)),
}))(Backhaul);



// WEBPACK FOOTER //
// ./src/components/search/results/LoadCard/BackhaulAlt/index.js